import React from "react";
import { useParams, Link } from "react-router-dom";
import { INDUSTRY_PAGES, SOLUTIONS } from "@/data/content";
import { isIndustry, rememberIndustry, track } from "@/lib/analytics";

export default function IndustryPage() {
  const { slug } = useParams();
  const ind = INDUSTRY_PAGES.find(i => i.slug === slug);
  React.useEffect(() => {
    if (!isIndustry(slug)) return;
    rememberIndustry(slug);
    track("industry_page_view", { industry: slug });
  }, [slug]);
  if (!ind) return <div className="pt-32 px-6 max-w-4xl mx-auto"><h1 className="font-display text-4xl">Industry not found.</h1><Link to="/" className="btn-ghost mt-6">← Back home</Link></div>;

  return (
    <main>
      <section className="relative pt-32 pb-24 overflow-hidden min-h-[70vh] flex items-center">
        <div className="absolute inset-0">
          <img src={ind.img} alt={ind.name} className="w-full h-full object-cover opacity-40"/>
          <div className="absolute inset-0 hero-overlay"/>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Link to="/#contact" className="btn-ghost mb-8 inline-flex" data-testid="industry-back">← Industries</Link>
          <div className="overline">Industry · {ind.name}</div>
          <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter mt-6 max-w-4xl" data-testid="industry-title">{ind.tagline}</h1>
          <p className="text-secondary text-lg mt-6 max-w-2xl">Purpose-built AI systems for {ind.name.toLowerCase()} businesses — designed around your workflows, your seasonality, and the way your customers expect to be treated.</p>
          <div className="mt-10 flex gap-4 flex-wrap">
            <a href="https://calendly.com/freedombyaidesign" target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="industry-cta-book">Book a Strategy Call</a>
            <Link to="/#audit" className="btn-ghost">Try the AI Business Audit →</Link>
          </div>
        </div>
      </section>

      <section className="py-24 bg-surface">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="overline">Recommended Systems</div>
          <h2 className="font-display font-light text-4xl md:text-5xl mt-4 max-w-3xl">What we typically build for {ind.name} clients.</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            {SOLUTIONS.slice(0,6).map((s, i) => (
              <div key={s.slug} className="editorial-card p-8">
                <div className="overline">{String(i+1).padStart(2,'0')}</div>
                <div className="font-display text-2xl mt-4">{s.problem}</div>
                <div className="text-brand text-xs tracking-widest uppercase mt-2">{s.product}</div>
                <p className="text-secondary text-sm mt-4 leading-relaxed">{s.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-display font-light text-4xl md:text-5xl">Ready to see what's possible for your {ind.name.toLowerCase()} business?</h2>
          <a href="https://calendly.com/freedombyaidesign" target="_blank" rel="noopener noreferrer" className="btn-primary mt-10 inline-flex" data-testid="industry-cta-bottom">Book a Consultation</a>
        </div>
      </section>
    </main>
  );
}
